export default "__VITE_ASSET__VAw4P84H__"